import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import appReducer from './appSlice';
import posCustomerReducer from './posCustomerSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    app: appReducer,
    posCustomer: posCustomerReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
